import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserLock, faChartLine, faBan, faCircleNotch, faPlug, faTachometerAlt, faArchive, faRecycle, faKey, faShieldAlt, faCloud, } from "@fortawesome/free-solid-svg-icons";
library.add(faUserLock, faChartLine, faBan, faCircleNotch, faPlug, faTachometerAlt, faArchive, faRecycle, faKey, faShieldAlt, faCloud);
